import { mockComments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">读者心声</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            来自虫虫漫画读者的真实评价，听听大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mockComments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}